<div [formGroup]="form" [hidden]="isHidden" class="control-container">
    <mat-form-field appearance="outline"
                    class="cp-input se-form-field"
                    [class.no-label]="!control.isWithLabel"
                    [ngSwitch]="control.controlType"
                    [matTooltip]="control.icon ? '' : control.tooltip"
                    matTooltipClass="mat-tooltip-cp no-margin"
                    matTooltipPosition="above"
                    matTooltipShowDelay="500">
        <mat-label>{{ control.isWithLabel ? control.name : '' }}</mat-label>

        <!-- NumericInteger -->
        <input *ngSwitchCase="7"
               matInput
               class="se-form-field-input"
               type="text"
               autocomplete="off"
               [errorStateMatcher]="errorStateMatcher"
               [formControlName]="control.id"
               [pattern]="control.pattern"
               [placeholder]="control.isWithLabel ? control.name : ''"
               (focus)="onFocus()" />

        <!-- NumericDecimal -->
        <input *ngSwitchCase="8"
               matInput
               class="se-form-field-input"
               type="text"
               autocomplete="off"
               [errorStateMatcher]="errorStateMatcher"
               [formControlName]="control.id"
               [pattern]="control.pattern"
               [placeholder]="control.isWithLabel ? control.name : ''"
               (focus)="onFocus()" />

        <!-- Money -->
        <input *ngSwitchCase="13"
               matInput
               class="se-form-field-input"
               type="text"
               autocomplete="off"
               [errorStateMatcher]="errorStateMatcher"
               [formControlName]="control.id"
               [pattern]="control.pattern"
               [placeholder]="control.isWithLabel ? control.name : ''"
               (focus)="onFocus()" />

        <mat-icon *ngIf="control.icon"
                  matSuffix
                  class="cp-suffix-icon"
                  [matTooltip]="control.tooltip"
                  matTooltipClass="mat-tooltip-cp"
                  matTooltipShowDelay="500">
            {{ control.icon }}
        </mat-icon>

        <mat-hint *ngIf="!formControl?.invalid"></mat-hint>
        <mat-error *ngIf="formControl?.invalid">{{ getErrorMessage() }}</mat-error>
    </mat-form-field>
</div>
